<template>
  <label class="flex items-center my-0 cursor-pointer">
    <input
      v-model="model"
      type="checkbox"
      class="sr-only peer !border-primary"
    >
    <span class="relative w-9 h-5 bg-gray-300 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-primary" />
    <span class="ms-3 text-sm font-medium text-primary">{{ text }}</span>
  </label>
</template>

<script setup>

defineProps({
  text: {
    type: String,
    default: '',
  },
});

const model = defineModel();

</script>
